exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".donate-type-inner{border:1px solid #dddddd;border-radius:4px;height:100%;padding:20px}.donate-type-inner h3{margin:0px 0px 20px 0px;font-weight:500}.donate-type-inner p{font-weight:300}.donate-type-inner a{font-size:15pt}.donate-type-inner strong{color:#b6102f;font-weight:500}.donate-type-column{padding:10px}@media screen and (max-width: 767px){.donate-type-column{padding:15px;width:100%}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/HomeElements/DonateType.scss
// module id = 1054
// module chunks = 0